import React, { useState } from 'react';
import businessLookupService from '../services/businessLookupService';

function BusinessLookup({ onBusinessSelect, initialData = {} }) {
  const [searchData, setSearchData] = useState({
    businessName: initialData.businessName || '',
    address: initialData.address || ''
  });
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchData.businessName.trim()) return;

    setLoading(true);
    setError('');
    
    try {
      const response = await businessLookupService.searchBusinesses(
        searchData.businessName,
        searchData.address
      );
      setResults(response.results || []);
    } catch (error) {
      console.error('Search error:', error);
      setError(error.message);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectBusiness = async (business) => {
    setLoading(true);
    try {
      const response = await businessLookupService.populateBusinessData(business.name, business.address);
      console.log('Populate response:', response);
      
      // The populate endpoint returns {populated_config: {...}, all_results: [...]}
      const populatedConfig = response.populated_config || response;
      
      // Map the populated config to the expected format
      const businessData = {
        name: populatedConfig.business_name || business.name,
        website: populatedConfig.website || business.website,
        phone: populatedConfig.phone_number || business.phone,
        address: populatedConfig.address || business.address,
        businessHours: populatedConfig.business_hours || business.hours
      };
      
      console.log('Mapped business data:', businessData);
      onBusinessSelect(businessData);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      background: 'white',
      padding: '2rem',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
      maxWidth: '600px',
      margin: '0 auto'
    }}>
      <h3 style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
        Find Your Business on Google Maps
      </h3>
      
      <form onSubmit={handleSearch} style={{ marginBottom: '2rem' }}>
        <div style={{ marginBottom: '1rem' }}>
          <input
            type="text"
            placeholder="Business Name"
            value={searchData.businessName}
            onChange={(e) => setSearchData({...searchData, businessName: e.target.value})}
            style={{
              width: '100%',
              padding: '0.75rem',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '1rem',
              marginBottom: '0.5rem'
            }}
            required
          />
          <input
            type="text"
            placeholder="City, State (optional)"
            value={searchData.address}
            onChange={(e) => setSearchData({...searchData, address: e.target.value})}
            style={{
              width: '100%',
              padding: '0.75rem',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '1rem'
            }}
          />
        </div>
        
        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '0.75rem',
            background: loading ? '#9ca3af' : '#2563eb',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '1rem',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Searching...' : 'Search Google Maps'}
        </button>
      </form>

      {error && (
        <div style={{
          background: '#fee2e2',
          color: '#dc2626',
          padding: '1rem',
          borderRadius: '6px',
          marginBottom: '1rem'
        }}>
          {error}
        </div>
      )}

      {results.length > 0 && (
        <div>
          <h4 style={{ marginBottom: '1rem' }}>Select Your Business:</h4>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {results.map((business, index) => (
              <div
                key={index}
                onClick={() => handleSelectBusiness(business)}
                style={{
                  padding: '1rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '6px',
                  marginBottom: '0.5rem',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s',
                  ':hover': { backgroundColor: '#f9fafb' }
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f9fafb'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
              >
                <div style={{ fontWeight: '600', marginBottom: '0.25rem' }}>
                  {business.name}
                </div>
                <div style={{ fontSize: '0.9rem', color: '#6b7280', marginBottom: '0.25rem' }}>
                  {business.address}
                </div>
                {business.rating && (
                  <div style={{ fontSize: '0.8rem', color: '#059669' }}>
                    ⭐ {business.rating} rating
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default BusinessLookup;